import React, { PropTypes } from 'react';
import { GPStoDecimal, shouldUpdatePoint } from '../../businessLogic/util';
import LightBox from '../Common/LightBox';

export default class PasteArea extends React.Component {

	constructor(props) {
		super(props);
		this.state = { 
			is_lightbox_open: false
		};
	}

	getStyle() {
		return {
			overlay: { backgroundColor: 'rgba(255, 255, 255, 0.75)' },
			content: { 
				height: `400px`,
				width: `400px`,
				overflowY: "auto", 
				overflowX: "hidden"
			}
		};
	}

	validateLatLng(latLng) {		
		const re = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;
		const GPSLat = /^([0-8]\dº)(\s?)(\d|[0-5]\d)(('|’)?)(\s?)(\d|[0-5]\d)(((")|('')|(”))?)(\s?)[NS]$/;
		const GPSLng = /^((0?[1-9]\d?|1[0-7]\d)º)(\s?)(\d|[0-5]\d)(('|’)?)(\s?)(\d|[0-5]\d)(((")|('')|(”))?)(\s?)[EW]$/;
		latLng.map((o) => {
			if ( o.length === 1 ) return;
			const lat = o[0].replace(",", ".");
			const lng = o[1].replace(",", ".");
			const label = o[2] ? o[2] : "";
			const value = `${lat},${lng}`;
			if ( re.test(value) ) {
				const point = { lat, lng };
				const samePoints = this.props.points.filter((basePoint) => !shouldUpdatePoint(basePoint, point));
				if ( samePoints.length === 0 ) this.props.createPoint({ lat: lat, lng: lng, label: label });				
			} else if ( GPSLat.test(lat) && GPSLng.test(lng) ) {
				const lat = GPStoDecimal(o[0]);
				const lng = GPStoDecimal(o[1]);
				const point = { lat, lng };
				const samePoints = this.props.points.filter((basePoint) => !shouldUpdatePoint(basePoint, point));
				if ( samePoints.length === 0 ) this.props.createPoint({ lat: lat, lng: lng, label: label });				
			} else console.error("Formato inválido!");
		});		
	}

	render () {	
		return (			
			<div>
				<button 
					type="button" 
					className="btn btn-primary btn-block"
					onClick={() => { this.setState({is_lightbox_open: true}); }}>
					Importar do excel
				</button>
				<LightBox						
					isOpen={this.state.is_lightbox_open}						 
					onClose={() => this.setState({is_lightbox_open: false})}
					>
					<div className="col-md-12">
						<span className="help-block" style={{marginBottom: "0px"}}>
							Grau Decimal ou Grau Minuto e Segundo'
						</span>
						<div className="form-group">
							<textarea 
								rows={12}
								placeholder="Cole aqui valores de latitude e longitude"						
								style={{width: "100%", resize: "none"}}
								onChange={(e) => {
									const array = e.target.value.split("\n");
									const latLng = array.map((e, i) => e.split("\t"));
									this.validateLatLng(latLng);
								}} />
						</div>
					</div>
				</LightBox>					
			</div>
		);
	}
}

PasteArea.propTypes = {
	points: PropTypes.array.isRequired,
	createPoint: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/PasteArea.js